import { render } from "./IntroGreeting.vue?vue&type=template&id=5ad96978&scoped=true"
import script from "./IntroGreeting.vue?vue&type=script&lang=js"
export * from "./IntroGreeting.vue?vue&type=script&lang=js"

import "./IntroGreeting.vue?vue&type=style&index=0&id=5ad96978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad96978"]])

export default __exports__